<template>
    <div>
        <div v-if="videos.length < 1" class="upload-photos">
            <span>{{text.add_your_videos_to_get_noticed}}</span>
            <label class="backToProfile uploadCover" @click="showUploadModal">
                {{word.add_video}}
            </label>
        </div>

        <div v-else class="upload-photos" style="text-align: inherit !important;">
            <div class="row w-100">
                <div class="col-lg-10 col-md-9">
                    <div class="row row-eq-height">
                        <div v-for="video in videos" class="col-lg-2 col-4 mt-1 mb-1">
                            <div class="thumbnail gallery-container">
                                <img v-if="!video.thumb || video.thumb === ''" class="gallery-photo full-width" :src="defaultThumb">
                                <img v-else class="gallery-photo full-width" :src="video.thumb">
                                <div class="gallery-actions">
                                    <a class="btn btn-danger btn-sm p-2" href="#" @click="showDeleteAlert(video.id)"><i class="fas fa-trash"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-2 col-md-3 align-self-center">
                    <label class="backToProfile uploadCover" @click="showUploadModal">
                        {{word.add_video}}
                    </label>
                </div>
            </div>
        </div>

        <loading
                color="green"
                :active="loading"
                spinner="bar-fade-scale"
        />

        <!--Upload modal-->
        <vue-modal
                :modal_title="word.upload_video"
                v-if="showModal"
                @close="closeModal"
                container_style="width: 50%; height:500px !important;"
                body_container_style="width: 100%; height:400px !important;"
        >
            <template v-slot:body>
                <div class="row h-100">
                    <div class="align-self-center w-100 pl-3 pr-3 pl-3 pb-3 pt-1">
                        <div class="row">
                            <div class="align-self-center w-100">
                                <file-pond
                                        name="test"
                                        ref="pond"
                                        v-model="video"
                                        :label-idle="text.drop_video_here"
                                        v-bind:allow-multiple="false"
                                        :files="video"
                                        accepted-file-types="video/mp4"
                                        maxFileSize="100MB"
                                />
                            </div>
                        </div>
                        <div class="row  mt-3">

                            <div class="align-self-center w-100">
                                <loading
                                        color="green"
                                        :active="loading"
                                        spinner="bar-fade-scale"
                                />

                                <div class="text-center">
                                    <button class="btn btn-info btn-lg" @click="uploadVideos">{{word.upload_video}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </template>
        </vue-modal>
    </div>

</template>

<script>

    import VueModal from "./../../VueModal";

    // Import Vue FilePond
    import vueFilePond from "vue-filepond";

    // Import FilePond styles
    import "filepond/dist/filepond.min.css";

    // Import FilePond plugins
    // Please note that you need to install these plugins separately

    // Import image preview plugin styles
    import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

    // Import image preview and file type validation plugins
    import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
    import FilePondPluginImagePreview from "filepond-plugin-image-preview";
    import FilePondPluginFileEncode from "filepond-plugin-file-encode";

    // Create component
    const FilePond = vueFilePond(
        FilePondPluginFileValidateType,
        FilePondPluginImagePreview,
        FilePondPluginFileEncode
    );

    export default {
        name: "upload-video",
        components: {
            VueModal,
        },

        props: [
            'userId'
        ],

        data() {
            return {
                word: window.word,
                text: window.text,
                loading: false,
                defaultThumb: '/images/layer.png',
                videos: [],
                showModal: false,
                video: [],
            }
        },

        mounted() {
            this.fetchVideos();
        },

        methods: {
            showUploadModal() {
                this.showModal = true;
            },
            closeModal() {
                this.showModal = false;
                this.video = [];
            },
            fetchVideos() {
                this.loading = true;
                let self = this;
                axios.get('/dashboard/user/' + this.userId + '/videos')
                    .then(response => {
                        this.videos= response.data.data;
                        self.loading = false;
                    })
                    .catch(error => {
                        console.log(error);
                        self.loading = false;
                    });
            },

            uploadVideos() {
                if (this.video[0].status === 8) {
                    this.$toast.error(this.text.invalid_file, {
                        queue: true
                    });
                    return;
                }
                this.loading = true;
                let self = this;

                let video = [];
                this.video.forEach(function (vid) {
                    video.push(vid.getFileEncodeDataURL());
                });
                let data = {
                    video: video,
                };

                axios({
                    method: "post",
                    url: "/en/dashboard/upload-gallery-video",
                    data
                })
                    .then(() => {
                        Bus.$emit('NewGalleryVideo');
                        this.$toast.success(text.video_uploaded_successfully);
                        this.closeModal();
                        self.loading = false;
                        self.fetchVideos();
                    })
                    .catch((err) => {
                        if (err.response.status == 422) {
                            let errors = err.response.data.errors;
                            self.errors = errors;
                            for (let error in errors) {
                                self.$toast.error(errors[error][0]);
                            }
                        } else {
                            this.$toast.error(text.can_not_upload_this_file_try_again);
                        }

                        this.closeModal();
                        self.loading = false;
                    });
            },

            showDeleteAlert(id){
                Swal.fire({
                    type: "question",
                    icon: "warning",
                    text: this.text.file_delete_question,
                    confirmButtonText: this.word.yes,
                    cancelButtonText: this.word.no,
                    showCancelButton: true,
                    showCloseButton: true
                }).then(result => {
                    if (result.value) {
                        this.deleteVideo(id);
                    }
                });
            },

            deleteVideo(id){
                this.loading = true;
                let self = this;
                axios.delete('dashboard/delete-gallery-video/'+id)
                    .then(()=>{
                        Bus.$emit('NewGalleryVideo');
                        this.$toast.success(text.video_deleted_successfully);
                        self.loading = false;
                        self.fetchVideos();
                    })
                    .catch(()=>{
                        this.$toast.error(text.can_not_delete_this_file_try_again);
                        self.loading = false;
                    });
            },
        }
    }
</script>

<style scoped>

</style>
